import { API_URL } from "../../environments/environment";
import { Contact } from "./Contact";
import { Model } from "./Concers/Model";
import { Component } from "./Component";

export class Article extends Model {
    id: number;
    article_type_id: number;
    title: string;
    profile_title: null;
    profile_description: null;
    profile_user_id: null;
    story_user_id: null;
    profile = null;
    story_profile = null;
    created_at: string;
    updated_at: string;
    components: Component[];
    reading_time: string;
    has_feature_image: boolean;
    published_at: null;
    is_favorite: boolean;

    public translatable = ["title"];

    getFeaturedImagePath() {
        return `${API_URL}/articles/${this.attributes.id}/featuredImage`;
    }

    constructor(item) {
        super(item);
        if (item !== null) {
            if (!!item.profile) {
                this.profile = new Contact(item.profile);
            }
            if (!!item.story_profile) {
                this.story_profile = new Contact(item.story_profile);
            }

            // Convert components to Component entities
            if (item.components && Array.isArray(item.components)) {
                this.components = item.components.map(
                    (comp) => new Component(comp)
                );
            }
        }
    }
}
